import { createSlice } from "@reduxjs/toolkit";

const initialState: string | null = localStorage.getItem("selLng") === null ? "ru" : localStorage.getItem("selLng");

const selLanguageSlice = createSlice({
    name: "selLanguage",
    initialState,
    reducers: {
        setSelLanguageInStore: (state, action) => {
            console.log(action)
            return action.payload;
        },
    },
});

export const { setSelLanguageInStore } = selLanguageSlice.actions;

export default selLanguageSlice.reducer;